import { VideoGenerator } from '../../classes/video-generator/video-generator';
import { ISubBlockVideos, ISubBlockVideosBo, TypeNameSubBlockVideos } from '../../components/block-text/videos/videos';
import { LoggerService } from '../../services/loggers';
import { LinkPresenter } from '../commons/link.presenter';
import { MediaImagePresenter } from '../commons/media-image.presenter';
import { ISubBlockPresenter } from '../presenter';

export class SubBlockVideosPresenter implements ISubBlockPresenter {
  constructor(private readonly logger: LoggerService) {}
  parse(data: ISubBlockVideosBo): ISubBlockVideos {
    const cover = MediaImagePresenter.getImage(data.imageCover);
    const subBlock: ISubBlockVideos = {
      __typename: TypeNameSubBlockVideos,
      id: data.id,
      title: data.title || '',
      video: data.video || '',
      youtubeVideoId: data.video ? VideoGenerator.youtubeParser(data.video) : null,
      cover,
      legend: data.legend || '',
      ctaLabel: data.CTABtn || '',
      ctaUrl: LinkPresenter.getLink(data.CTAUrl),
    };

    if (data.video && !subBlock.youtubeVideoId) {
      this.logger.warn(`[SubBlockVideosPresenter] The video URL "${data.video}" is not a valid Youtube URL.`);
    }

    return subBlock;
  }
}
